import { useTranslation } from 'react-i18next';
import type { GridColumnHeaderParams } from '@mui/x-data-grid-pro';
import { GridColumnHeaderTitle } from '@mui/x-data-grid-pro';

export function DataGridTranslatedColumnHeader({
  labelKey,
  params,
  keyPrefix,
  labelSuffix = '',
}: {
  labelKey: string;
  params: GridColumnHeaderParams;
  keyPrefix: string;
  labelSuffix?: string;
}) {
  const { t } = useTranslation([], { keyPrefix });
  const columnWidth = params.colDef.computedWidth ?? params.colDef.width ?? 100;
  return (
    <GridColumnHeaderTitle
      label={t(labelKey) + labelSuffix}
      columnWidth={columnWidth}
    />
  );
}

/** Column titles that are not i18n keys (literals). */
export function DataGridStaticColumnHeader({
  label,
  params,
}: {
  label: string;
  params: GridColumnHeaderParams;
}) {
  const columnWidth = params.colDef.computedWidth ?? params.colDef.width ?? 100;
  return <GridColumnHeaderTitle label={label} columnWidth={columnWidth} />;
}
